import React from 'react';
import SvgIcon, { IconProps, getColor } from './SvgIcon';

export default function BoldIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fill="none"
        stroke={getColor(props.color)}
        strokeWidth="1.5"
        d="M5.3 12h8c1.6 0 4.7.7 4.7 4.6 0 4-3.4 4.4-4.7 4.4H7.2c-1.8 0-2.3-1.6-2.3-2.4V5.7c0-1 .4-2.8 2.3-2.8h5c1.4 0 4.7.3 4.7 4.3 0 3.9-2 4.7-4.8 4.7H6.8"
      />
    </SvgIcon>
  );
}
